import type { ReportFreshness } from "@nexus/widget-kit";

export const CDNSA_CDN_COMPARISON_CONTRACT = { name: "cdnsa-cdn-comparison", version: 1 } as const;

export interface CdnsaCdnComparisonData {
  points: {
    cdn: string;
    bucket_kind: "provider" | "unattributed" | "other";
    infringement_type: "theft_for_restreaming" | "cdn_leeching";
    value: number;
  }[];
  measure: "infringements" | "accounts" | "ips";
  freshness: ReportFreshness | null;
}
